var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.098 20.8l-7.04-10.257.012.008 6.344-7.352h-2.117l-5.168 5.985-4.106-5.985H3.465l6.566 9.578-6.926 8.024h2.118l5.746-6.66 4.566 6.66zM8.184 4.8l9.87 14.4h-1.679L6.496 4.8zm0 0"
  })));
}

export default SvgX;